import * as i0 from '@angular/core';
import { Directive, Input } from '@angular/core';
import { NgClassSwitch } from '@ng-dot/core';
import { DotInheritBase } from '@ng-dot/ux/inherit';
class DotColorDirective extends DotInheritBase {
  color;
  _classState;
  constructor(elementRef) {
    super();
    this._classState = new NgClassSwitch(elementRef.nativeElement, {
      prefix: '_'
    });
  }
  ngOnInit() {
    this.render();
  }
  ngOnChanges(changes) {
    for (let property in changes) {
      if (!changes.hasOwnProperty(property)) {
        continue;
      }
      this[property] = changes[property].currentValue;
    }
    if ('color' in changes) {
      this.render();
    }
  }
  dotOnInherit() {
    this.render();
  }
  render() {
    const {
      _classState
    } = this;
    const color = this.inherit('color');
    if (color) {
      _classState.set(migration_colorLabel(color));
    } else {
      _classState.pop();
    }
  }
  static ɵfac = function DotColorDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotColorDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotColorDirective,
    selectors: [["", "dotColor", ""]],
    inputs: {
      color: "color"
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotColorDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotColor]'
    }]
  }], () => [{
    type: i0.ElementRef
  }], {
    color: [{
      type: Input
    }]
  });
})();
// export const DOT_COLOR_DIRECTIVE = {
// 	directive: DotColorDirective,
// 	inputs: ['color']
// }
function migration_colorLabel(color) {
  switch (color) {
    case 'primary':
      console.warn('[DEPRECATED] `primary` changed to `main`');
      return 'main';
    case 'accent':
      console.warn('[DEPRECATED] `accent` changed to `point`');
      return 'point';
  }
  return color;
}

/**
 * Generated bundle index. Do not edit.
 */

export { DotColorDirective, migration_colorLabel };
